export default "__VITE_ASSET__Ck_NdO6D__"